module.exports = __webpack_public_path__ + "img/chadan.b5f9b1e.svg";